module.exports = __webpack_public_path__ + "static/media/typ3.1ac3dc7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/typ3.png
// module id = 689
// module chunks = 0